<template>
    <div class="animated fadeIn">
        <table
            v-if="prices.length > 0"
            class="kgr-table kgr-table--block kgr-table--striped data-table table-groups table-employees printable"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('offering.pricetype') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('offering.clubFee') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('offering.department') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('offering.team') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline">
                        {{ $t('offering.price') }}
                    </th>
                    <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions">
                        {{ $t('offering.edit') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(price, index) in prices"
                    :key="price.id"
                    class="kgr-table__row"
                >
                    <td class="kgr-table__cell">
                        {{ (price.type ? price.type.name : '') }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ (price.clubFee ? price.clubFee.name : $t('offering.free')) }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ (price.department ? price.department.label : '') }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ (price.team ? price.team.label : '') }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ parseFloat(price.divergentAmount) > 0 ? formatCurrency(parseFloat(price.divergentAmount)) : '-' }}
                    </td>
                    <td class="kgr-table__cell kgr-table__cell--actions">
                        <button
                            class="kgr-table__action"
                            @click="edit(price, index)"
                        >
                            <kgr-icon-edit :size="15" />
                        </button>
                        <button
                            class="kgr-table__action"
                            @click="remove(index)"
                        >
                            <kgr-icon-delete :size="15" />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-empty-data
            v-else
            :value="$t('offering.offeringIsFree')"
        />
    </div>
</template>

<script>
import EmptyData from '../../components/common/EmptyData';
import Helper from '../../js/accounting/Helper';
import IconDelete from '../../components/common/icon/IconDelete';
import IconEdit from '../../components/common/icon/IconEdit';

export default {
    name: 'KgrPriceTable',
    components: {
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
        'kgr-empty-data': EmptyData,
    },
    props: {
        filter: {
            type: String,
            required: false,
            default: '',
        },
        prices: {
            type: Array,
            required: false,
            default: () => [],
        },
        locale: {
            type: String,
            required: false,
            default: 'de-DE',
        },
        currency: {
            type: String,
            required: false,
            default: 'EUR',
        },
    },
    methods: {
        remove(index) {
            this.$emit('remove_price', index);
        },
        edit(price, index) {
            this.$emit('edit_price', price, index);
        },
        formatCurrency(amount) {
            return new Helper().numberFormat(amount, this.locale, this.currency);
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
